//  I have given more contnet right ? is this enough for one page ? also add FAQ like civil and interior , now add the same list which is same in civil FAQ , now use the same list for FAQ add in evcharger.json and use the same for like civil FAQ for civil screen
import React, { useEffect } from 'react';
import Metatag from '../../components/Metatag/Metatag';
import Contacthome from '../../components/contacthome/contacthome';
import Faq from '../../components/Faq/Faq';
import evchargerImg from '../../assets/images/evcharger.png';
import evchargerData from '../../assets/files/evcharger.json';

const Evcharger = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Transform FAQ data for Faq component
    const faqItems = evchargerData.faq.map(item => ({
        title: item.question,
        content: item.answer
    }));

    return (
        <>
            <Metatag 
                title={evchargerData.seo.title} 
                description={evchargerData.seo.description} 
                link={evchargerData.seo.link} 
            />
            
            <div className="bg-[#fdaa2f] p-8 text-center pt-14">
                <h1 className="text-2xl font-bold uppercase md:text-5xl text-black">{evchargerData.hero.title}</h1>
            </div>

            <div className="container mx-auto p-4 md:py-16 grid grid-cols-1 md:grid-cols-2 gap-8 items-center mt-5">
                <div>
                    <img src={evchargerImg} alt="EV Charger Installation in Dubai" className="w-full h-auto rounded-xl shadow-[0_1rem_3rem_rgba(0,0,0,.18)]" />
                </div>
                <div>
                    <p className="text-lg md:text-[18px] text-[#7a7a7a] leading-8 text-justify">
                        <strong className="text-black">{evchargerData.intro.boldText}</strong> {evchargerData.intro.paragraph1} <br/><br/>
                        {evchargerData.intro.paragraph2}
                    </p>
                </div>
            </div>

            <div className="bg-[#e5e7eb] py-16">
                <div className="container mx-auto p-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 uppercase">{evchargerData.services.sectionTitle}</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {evchargerData.services.items.map((service, index) => (
                            <div key={index} className="bg-white p-6 rounded-lg shadow-lg border-t-4 border-orange hover:-translate-y-2 transition-transform duration-300">
                                <h3 className="text-xl font-bold mb-4">{service.title}</h3>
                                <ul className="text-[15px] space-y-2 text-[#7a7a7a] leading-6 list-none font-semibold">
                                    {service.points.map((point, idx) => (
                                        <li key={idx} className="flex items-start">
                                            <span className="text-orange mr-2">●</span> {point}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="container mx-auto p-4 py-16">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
                    <div>
                        <h2 className="text-3xl md:text-4xl font-bold mb-8 uppercase text-center lg:text-left">{evchargerData.process.sectionTitle}</h2>
                        <div className="space-y-6">
                            {evchargerData.process.steps.map((step, index) => (
                                <div key={index} className="flex items-center">
                                    <span className="h-12 w-12 flex-shrink-0 bg-orange text-black font-bold text-xl flex justify-center items-center rounded-full shadow-lg border-2 border-black mr-4">
                                        {index + 1}
                                    </span> 
                                    <p className="text-[18px] font-semibold text-gray-700">{step}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div>
                        <div className="bg-black text-white p-8 rounded-2xl shadow-xl">
                            <h2 className="text-3xl font-bold mb-6 text-orange uppercase">{evchargerData.whyChooseUs.sectionTitle}</h2>
                            <ul className="space-y-4 text-[17px]">
                                {evchargerData.whyChooseUs.points.map((point, index) => (
                                    <li key={index} className="flex items-center">
                                        <span className="mr-3 text-xl">{point.icon}</span> {point.text}
                                    </li>
                                ))}
                            </ul>
                            
                            <h2 className="text-3xl font-bold mt-10 mb-6 text-orange uppercase">{evchargerData.whereWeWork.sectionTitle}</h2>
                            <ul className="space-y-4 text-[17px]">
                                {evchargerData.whereWeWork.points.map((point, index) => (
                                    <li key={index} className="flex items-center">
                                        <span className="mr-3 text-xl">{point.icon}</span> {point.text}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-orange py-16 text-center">
                <div className="container mx-auto p-4">
                    <h2 className="text-2xl md:text-5xl font-bold mb-4 text-black uppercase">{evchargerData.cta.title}</h2>
                    <p className="text-xl md:text-2xl mb-8 font-semibold text-[#313131]">{evchargerData.cta.subtitle}</p>
                    <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-10">
                        <div className="bg-black text-white py-3 px-8 rounded-full text-lg font-semibold flex items-center shadow-lg">
                            <span className="mr-2">{evchargerData.cta.phoneLabel}</span> {evchargerData.cta.phone}
                        </div>
                        <div className="bg-black text-white py-3 px-8 rounded-full text-lg font-semibold flex items-center shadow-lg">
                            <span className="mr-2">{evchargerData.cta.emailLabel}</span> {evchargerData.cta.email}
                        </div>
                    </div>
                    <a href={evchargerData.cta.buttonLink} className="inline-block bg-black text-orange border-2 border-black font-bold text-[16px] xl:text-xl py-3 md:py-4 px-6 md:px-10 rounded-full hover:bg-white hover:text-black hover:border-white transition-all duration-300 shadow-[0_1rem_3rem_rgba(0,0,0,.3)]">
                        {evchargerData.cta.buttonText}
                    </a>
                </div>
            </div>

            <Faq items={faqItems} />
            <Contacthome />
        </>
    );
};

export default Evcharger;
